document.addEventListener("DOMContentLoaded", function() {
  // Loop over each slider container on the page
  document.querySelectorAll('.mySwiper').forEach(function(sliderEl) {
    var sectionRoot = sliderEl.closest('section') || sliderEl.parentElement;
    var nextButton = sectionRoot ? sectionRoot.querySelector('.only-for-product-lp-next') : null;
    var prevButton = sectionRoot ? sectionRoot.querySelector('.only-for-product-lp-prev') : null;
    var paginationEl = sectionRoot ? sectionRoot.querySelector('.swiper-pagination') : null;

    // Parse the JSON settings from the data attribute
    var settings = JSON.parse(sliderEl.getAttribute('data-slider-settings'));

    var desktopSlides = settings.desktopSlides || 5.5;
    var mobileSlides  = settings.mobileSlides || 4;
    var autoplayEnabled = settings.autoplayEnabled || false;
    var loopWhenAutoplayDisabled = settings.loopWhenAutoplayDisabled || false;
    var autoplayDelay = settings.autoplayDelay || 3000;
    var autoScrollDirection = settings.autoScrollDirection || "right";
    var gap = settings.gap || 0; // default gap
    var useFixedWidth = settings.useFixedWidth || false;
    var fixedProductWidth = settings.fixedProductWidth || 300;
    var fixedProductWidthDesktop = settings.fixedProductWidthDesktop || fixedProductWidth || 320;
    var fixedProductWidthMobile = settings.fixedProductWidthMobile || fixedProductWidth || 260;
    var smoothScroll = settings.smoothScroll || false;
    var scrollSpeed = settings.scrollSpeed || 1;
    var mobileBreakpoint = 768;

    var getResponsiveMobileWidth = function() {
      var configuredMobileSlides = parseFloat(mobileSlides) || 1;
      var visibleSlides = Math.max(configuredMobileSlides, 1);
      var sliderWidth = sliderEl.clientWidth || window.innerWidth || fixedProductWidthMobile;
      var visibleGapCount = Math.max(visibleSlides - 1, 0);
      var calculatedWidth = (sliderWidth - (gap * visibleGapCount)) / visibleSlides;

      return Math.max(Math.floor(calculatedWidth), 1);
    };

    // Build the configuration object for this slider instance.
    var swiperConfig = {
      loop: autoplayEnabled || loopWhenAutoplayDisabled,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      spaceBetween: gap, // Add the gap here (in px)
      speed: 300, // Default transition speed in milliseconds
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      pagination: {
        el: paginationEl,
        clickable: true
      },
      direction: "horizontal"
    };

    // Configure slides per view based on fixed width setting
    if (useFixedWidth) {
      swiperConfig.slidesPerView = 'auto';
      // Set fixed width on product items
      var productItems = sliderEl.querySelectorAll('.swiper-slide');
      var applyFixedWidths = function() {
        var isDesktop = window.innerWidth >= mobileBreakpoint;
        var width = isDesktop ? fixedProductWidthDesktop : getResponsiveMobileWidth();

        productItems.forEach(function(item) {
          item.style.width = width + 'px';
          item.style.flexShrink = '0';
        });
      };

      applyFixedWidths();

      window.addEventListener('resize', applyFixedWidths);

      productItems.forEach(function(item) {
        item.style.flexShrink = '0';
      });
    } else {
      swiperConfig.slidesPerView = mobileSlides;
      swiperConfig.breakpoints = {
        768: {
          slidesPerView: desktopSlides
        }
      };
    }

    // Add autoplay if enabled
    if (autoplayEnabled) {
      if (smoothScroll) {
        // For true smooth infinite scrolling, use custom continuous animation
        swiperConfig.loop = true; // Enable infinite loop
        swiperConfig.loopedSlides = Math.min(10, sliderEl.querySelectorAll('.swiper-slide').length); // Ensure enough slides for smooth loop
        swiperConfig.autoplay = false; // Disable Swiper's autoplay, we'll handle it manually
        
        // Enable freeMode for smoother transitions
        swiperConfig.freeMode = {
          enabled: true,
          momentum: false,
          sticky: false
        };
        
        // Set a reasonable transition speed
        swiperConfig.speed = 1000;
        
        // Initialize custom smooth infinite scroll after Swiper is ready
        setTimeout(function() {
          var swiper = sliderEl.swiper;
          if (swiper) {
            var isScrolling = true;
            var slideWidth = swiper.slides[0] ? swiper.slides[0].offsetWidth + gap : 300;
            var autoScrollTimeout;
            
            // Convert speed setting to appropriate timing
            // scrollSpeed 0.1 = very slow, 1.0 = normal, 5.0 = fast
            var slideTransitionTime = Math.max(1000, 5000 / scrollSpeed); // Time to move one slide width
            
            function smoothInfiniteScroll() {
              if (!isScrolling) return;
              
              // Use Swiper's slideNext for proper infinite loop handling
              if (autoScrollDirection === "left") {
                swiper.slidePrev(slideTransitionTime, false); // Smooth transition, no callback
              } else {
                swiper.slideNext(slideTransitionTime, false); // Smooth transition, no callback
              }
              
              // Schedule next movement
              autoScrollTimeout = setTimeout(smoothInfiniteScroll, slideTransitionTime);
            }
            
            // Function to restart auto scroll after manual navigation
            function restartAutoScroll() {
              if (autoScrollTimeout) {
                clearTimeout(autoScrollTimeout);
              }
              // Wait a bit after manual navigation, then resume
              autoScrollTimeout = setTimeout(function() {
                if (isScrolling) {
                  smoothInfiniteScroll();
                }
              }, slideTransitionTime);
            }
            
            // Handle navigation button clicks
            var nextBtn = nextButton;
            var prevBtn = prevButton;
            
            if (nextBtn) {
              nextBtn.addEventListener('click', function() {
                clearTimeout(autoScrollTimeout); // Stop auto scroll
                swiper.slideNext(300); // Quick manual transition
                restartAutoScroll(); // Resume auto scroll after delay
              });
            }
            
            if (prevBtn) {
              prevBtn.addEventListener('click', function() {
                clearTimeout(autoScrollTimeout); // Stop auto scroll
                swiper.slidePrev(300); // Quick manual transition
                restartAutoScroll(); // Resume auto scroll after delay
              });
            }
            
            // Start the smooth infinite scroll
            smoothInfiniteScroll();
            
            // Pause on hover
            sliderEl.addEventListener('mouseenter', function() {
              isScrolling = false;
              clearTimeout(autoScrollTimeout);
            });
            
            sliderEl.addEventListener('mouseleave', function() {
              isScrolling = true;
              restartAutoScroll();
            });
          }
        }, 500); // Give Swiper time to initialize
        
      } else {
        // Regular autoplay mode
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          reverseDirection: autoScrollDirection === "left"
        };
      }
    }
    
    // Initialize a new Swiper instance for this slider element.
    new Swiper(sliderEl, swiperConfig);
  });
});
